import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

export default function ProgramCard({ program, index = 0 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 60 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.8, ease: [0.76, 0, 0.24, 1], delay: index * 0.08 }}
      data-testid={`program-card-${program.id}`}
    >
      <Link to={`/programs/${program.id}`} className="group block">
        <div className="relative overflow-hidden bg-soma-surface border border-soma-border aspect-[4/5]">
          <img src={program.image} alt={program.name} loading="lazy"
            className="w-full h-full object-cover opacity-70 transition-[transform,opacity] duration-700 ease-out group-hover:scale-105 group-hover:opacity-90" />
          <div className="absolute inset-0 bg-gradient-to-t from-soma-bg via-soma-bg/20 to-transparent" />
          <div className="absolute top-5 left-5 flex items-center gap-2">
            <span className="text-[11px] uppercase tracking-[0.2em] px-3 py-1 border border-white/20 bg-black/40 backdrop-blur-sm text-white">
              {program.level}
            </span>
          </div>
          <div className="absolute top-5 right-5 w-10 h-10 rounded-full border border-white/20 flex items-center justify-center bg-black/30 backdrop-blur-sm transition-all duration-500 group-hover:bg-soma-primary group-hover:border-soma-primary">
            <ArrowUpRight className="w-4 h-4 text-white group-hover:text-soma-bg transition-colors" />
          </div>
          <div className="absolute bottom-0 left-0 right-0 p-6">
            <p className="font-serif-editorial italic text-sm mb-1" style={{ color: program.accent }}>{program.tagline}</p>
            <h3 className="font-display text-2xl font-semibold text-white mb-2">{program.name}</h3>
            <div className="flex items-center justify-between">
              <span className="text-soma-muted text-sm">{program.duration}</span>
              <span className="text-white font-semibold">
                ${program.price}<span className="text-soma-muted text-sm">/{program.interval === "year" ? "yr" : program.interval === "month" ? "mo" : "once"}</span>
              </span>
            </div>
          </div>
        </div>
      </Link>
    </motion.div>
  );
}
